Foundation.Mobile.Location = function (componentId, options = {}) {
    var cookies = Foundation.Mobile.Cookies;

    var message_box = jQuery('.message-box');
    var message_text = jQuery('.message-box .message-text');
    var result_box = jQuery('.results');

    var defaultPosition = (options.defaultPosition) ? options.defaultPosition : null;

    var updateResults = function (position) {
        message_text.text('Loading Results...');

        cookies.setItem('gyrobase-latitude',  position.coords.latitude, 600);
        cookies.setItem('gyrobase-longitude',  position.coords.longitude, 600);

        jQuery.ajax({
            data:{
                ajaxComponent: componentId
            },
            success : function (data) {
                message_box.hide();
                result_box.html(data);

                jQuery(document).ready(function () {
                    try {
                        // find panel links in data
                        var panel_links = result_box.find('a.ev-nested-list');
                        var panels = Foundation.Mobile.instance.panel_views;
                        jQuery.each(panel_links, function (index, el) {
                            // if panel is already instantiated reconect click event.

                            var link_target = el.href.split('#')[1];
                            var found = false;
                            for (var i = 0; i < panels.length; i++) {
                                var panel = panels[i];
                                var panel_id = panel.element[0].id;
                                if (panel_id == link_target) {
                                    jQuery(el).on('click', panel._handleClick.bind(panel));
                                    found = true;
                                }
                            }

                            // else instantiate panel.
                            if (!found) {
                                var inst = Foundation.Mobile.instance;
                                inst._panel_init.call(inst, result_box.find(`#${link_target}`));
                            }
                        });
                    }
                    catch (e) {
                        // console.log(e);
                    }
                });
            },
            error : function () {
                message_box.show();
                message_text.text('Error getting neraby locations.');
            }
        });
    }

    var geoOptions = {
        on_request : function () {
            message_text.text('Attempting to determine your location...');
        },
        on_success : updateResults,
        on_failure : function (err) {
            if (defaultPosition) {
                if (err.code == 1) {
                    message_text.text('Unable to determine your location. Using default location.');
                }
                else if (err.code == 2) {
                    message_text.text('Unable to determine your location. Using default location.');
                }
                else if (err.code == 3) {
                    message_text.text('Unable to determine your location. Using default location.');
                }
                else {
                    message_text.text('Unable to determine your location. Using default location.');
                }
                // Using default positioning. Let that sink in for a few seconds before updating.
                setTimeout( function () {
                    updateResults(defaultPosition);
                    geo.defaultPosition = defaultPosition
                    geo.locationAvalible = true
                    geo.updatePosition()
                }, 8000)
            }
            else {
                message_box.show();
                message_box.addClass('transparent');
                message_box.find('.dimmer').addClass('error message').removeClass('dimmer');
                message_box.find('.message .message-text').removeClass('loader');

                if (err.code == 1) {
                    message_text.text('Could not provide nearby results. Please allow geolocation in your browser.');
                }
                else if (err.code == 2) {
                    message_text.text('Could not provide nearby results. Unable to determine your location.');
                }
                else if (err.code == 3) {
                    message_text.text('Could not provide nearby results. It took too long to determine your location.');
                }
                else {
                    message_text.text('Could not provide nearby results. Unable to determine your location.');
                }
                // Load default results.

                // Make sure only sort is changed.
                var current_url = new Foundation.URL(window.location.href)
                current_url.set('sortType', 'name')
                current_url.set('ajaxComponent', componentId)

                jQuery.ajax({
                    url : current_url.toString(),
                    success : function (data) {
                        result_box.html(data);
                    },
                    error : function () {
                        message_box.show();
                        message_text.text('Error getting results.');
                    }
                });
            }
        }
    };

    var geo = new Foundation.Mobile.Geo(geoOptions);
    geo.updatePosition();
};

/* eslint eqeqeq: "off" */
